<template>
	<div class="modal fade show" tabindex="-1" role="dialog" style="display: block; background: rgba(0, 0, 0, 0.5);">
		<div class="modal-dialog modal-lg modal-fullscreen-sm-down" role="document">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white">
					<h5 class="modal-title">{{ notaSpesa ? 'Modifica Nota Spesa' : 'Nuova Nota Spesa' }}</h5>
					<span v-if="bloccato" class="badge bg-warning text-dark ms-auto me-2"><i class="ph-lock me-1"></i>In modifica da {{ lock.USERNAME }} — sola lettura</span>
					<button type="button" class="btn-close btn-close-white" :class="{ 'ms-0': bloccato }" @click="close()"></button>
				</div>

				<div class="modal-body">
					<form @submit.prevent="salvaSpesa(false)">
						<fieldset :disabled="bloccato">
						<div class="row">
							<div class="col-12 col-md-4 mb-2">
								<label class="form-label">Utente</label>
								<select v-model="form.FK_ID_UTENTE" class="form-control" required>
									<option value="">Seleziona...</option>
									<option v-for="u in $root.utentiAdminAttivi" :key="u.ID_UTENTE" :value="u.ID_UTENTE">
										{{ u.USERNAME }}
									</option>
								</select>
								<small class="text-muted d-block mt-1" v-if="form.FK_ID_UTENTE && dataLimite">
									Data limite: <strong>{{ formatData(dataLimite) }}</strong>
								</small>
								<small class="text-danger d-block mt-1" v-if="form.FK_ID_UTENTE && !dataLimite">
									Primo inserimento per questo utente
								</small>
							</div>

							<div class="col-6 col-md-3 mb-2">
								<label class="form-label">Data *</label>
								<Datepicker
									v-model="form.DATA"
									placeholder="Seleziona data"
									:formats="{ input: 'dd/MM/yyyy' }"
									:class="{ 'is-invalid': dataWarning }"
									auto-apply
									style="width:100%"
									@update:model-value="checkDataWarning"
								/>
								<div class="invalid-feedback d-block" v-if="dataWarning">
									Attenzione: data uguale o precedente al limite ({{ formatData(dataLimite) }})
								</div>
							</div>

							<div class="col-6 col-md-2 mb-2">
								<label class="form-label">Importo *</label>
								<input
									type="number"
									v-model.number="form.IMPORTO"
									step="0.01"
									min="0"
									class="form-control"
									placeholder="0.00"
									required
								/>
							</div>

							<div class="col-12 col-md-3 mb-2">
								<label class="form-label">Tipo *</label>
								<select v-model.number="form.TIPO_MOVIMENTO" class="form-control" required>
									<option :value="0">Addebito (uscita)</option>
									<option :value="1">Accredito (entrata)</option>
								</select>
							</div>
						</div>

						<div class="row">
							<div class="col-12 col-md-3 mb-2">
								<label class="form-label">Categoria</label>
								<select v-model="form.FK_ID_CATEGORIA" class="form-control">
									<option value="">Nessuna</option>
									<option v-for="c in arrayCategorieSpese" :key="c.ID_OPZIONE_TIPOLOGICA" :value="c.ICONA">
										{{ c.DESCRIZIONE }}
									</option>
								</select>
							</div>
							<div class="col-12 col-md-3 mb-2">
								<label class="form-label">Tipo giustificativo</label>
								<select v-model.number="form.FLG_FATTURA" class="form-control">
									<option :value="null">Non attribuito</option>
									<option :value="0">Scontrino</option>
									<option :value="1">Fattura</option>
								</select>
							</div>
							<div class="col-12 col-md-6 mb-2">
								<label class="form-label">Progetto</label>
								<select v-model="form.FK_ID_PROGETTO" class="form-control" :disabled="loadingProgetti">
									<option value="">Nessun progetto</option>
									<option v-for="p in arrayProgetti" :key="p.ID_PROGETTO" :value="p.ID_PROGETTO">
										{{ filters.titoloConTipologia(p) }}
									</option>
								</select>
							</div>
						</div>

						<div class="row">
							<div class="col-12 mb-2">
								<label class="form-label">Descrizione *</label>
								<textarea
									v-model="form.DESCRIZIONE"
									class="form-control"
									rows="1"
									placeholder="es. Ristorante, Hotel, Trasporto..."
									required
								></textarea>
							</div>
						</div>

						</fieldset>

						<div class="mb-2" v-if="notaSpesa && notaSpesa.FILE_ALLEGATO">
							<a href="#" @click.prevent="openAllegatoStorico()" class="btn btn-sm btn-outline-secondary">
								<i class="fas fa-file-pdf me-1"></i>Visualizza allegato storico
							</a>
						</div>

						<div v-if="message" class="alert" :class="messageClass" role="alert">
							{{ message }}
						</div>

						<div class="modal-footer">
							<button type="button" class="btn btn-sm btn-link" @click="close()">Annulla</button>
							<button v-if="!bloccato && $root.hasFunzionalita(notaSpesa ? 'NOTE_SPESE_UPDATE' : 'NOTE_SPESE_CREATE')" type="submit" class="btn btn-sm btn-secondary" :disabled="loading">
								<i class="ph-check me-1"></i>Salva e chiudi
							</button>
							<button v-if="!notaSpesa && $root.hasFunzionalita('NOTE_SPESE_CREATE')" type="button" class="btn btn-sm btn-primary" :disabled="loading" @click="salvaSpesa(true)">
								<i class="ph-check me-1"></i>Salva e continua
							</button>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { VueDatePicker as Datepicker } from '@vuepic/vue-datepicker';

export default {
	name: 'ModalNuovaSpesa',
	components: {
		Datepicker
	},
	props: {
		defaultIdProgetto: { type: [Number, String], default: null },
		notaSpesa: { type: Object, default: null }
	},
	emits: ['close', 'saved'],
	data() {
		return {
			form: {
				FK_ID_UTENTE: '',
				DATA: '',
				IMPORTO: '',
				DESCRIZIONE: '',
				FK_ID_PROGETTO: this.defaultIdProgetto || '',
				FLG_ATTIVO: 1,
				TIPO_MOVIMENTO: 0,
				FK_ID_CATEGORIA: '',
				FLG_FATTURA: null
			},
			dataLimite: null,
			dataWarning: false,
			message: '',
			messageClass: '',
			loading: false,
			arrayCategorieSpese: [],
			arrayProgetti: [],
			loadingProgetti: false,
			lock: null,
			lockHandle: null,
			filters: global.filters
		};
	},
	computed: {
		bloccato() { return this.lock != null && !this.lock.MIO; }
	},
	watch: {
		'form.FK_ID_UTENTE': function(newVal) {
			if (newVal) {
				this.getDataLimite();
			} else {
				this.dataLimite = null;
			}
		},
		notaSpesa: {
			immediate: true,
			handler(nota) {
				if (nota) {
					utils.lock.release(this.lockHandle);
					this.lockHandle = utils.lock.acquire('NOTA_SPESA', nota.ID_NOTA_SPESA, (stato) => this.lock = stato, () => {
						utils.get('theb/note_spese/progetto', { FK_ID_PROGETTO: nota.FK_ID_PROGETTO || this.defaultIdProgetto }, (r) => {
							var n = r.esito == 0 ? (r.data || []).find(x => x.ID_NOTA_SPESA == nota.ID_NOTA_SPESA) : null;
							if (n) this.riempiForm(n);
						});
					});
					this.riempiForm(nota);
				} else {
					// Create mode: reset form
					this.form = {
						FK_ID_UTENTE: '',
						DATA: '',
						IMPORTO: '',
						DESCRIZIONE: '',
						FK_ID_PROGETTO: this.defaultIdProgetto || '',
						FLG_ATTIVO: 1,
						TIPO_MOVIMENTO: 0,
						FK_ID_CATEGORIA: '',
						FLG_FATTURA: null
					};
					this.dataLimite = null;
				}
				this.message = '';
				this.messageClass = '';
			}
		}
	},
	created() {
		utils.get('shared/tipologica/lista', { FK_ID_MODULO: 63 }, (res) => {
			if (res.esito == 0 && res.data.length > 0) {
				utils.get('shared/tipologica', { ID_TIPOLOGICA: res.data[0].ID_TIPOLOGICA }, (res2) => {
					if (res2.esito == 0) this.arrayCategorieSpese = res2.data.opzioni || [];
				});
			}
		});
		this.loadingProgetti = true;
		utils.get('theb/progetto/lista', {}, (res) => {
			if (res.esito == 0) this.arrayProgetti = res.data || [];
			this.loadingProgetti = false;
		});
	},
	beforeUnmount() {
		utils.lock.release(this.lockHandle);
	},
	methods: {
		// Edit mode: pre-fill form
		riempiForm(nota) {
			this.form = {
				FK_ID_UTENTE: nota.FK_ID_UTENTE,
				DATA: nota.DATA,
				IMPORTO: nota.IMPORTO,
				DESCRIZIONE: nota.DESCRIZIONE,
				FK_ID_PROGETTO: nota.FK_ID_PROGETTO || this.defaultIdProgetto || '',
				FLG_ATTIVO: nota.FLG_ATTIVO,
				TIPO_MOVIMENTO: nota.TIPO_MOVIMENTO ?? 0,
				FK_ID_CATEGORIA: nota.FK_ID_CATEGORIA || '',
				FLG_FATTURA: nota.FLG_FATTURA ?? null
			};
			if (nota.FK_ID_UTENTE) {
				this.getDataLimite();
			}
		},
		openAllegatoStorico() {
			utils.ajaxBlob('theb/note_spese/allegato', { ID_NOTA_SPESA: this.notaSpesa.ID_NOTA_SPESA }, (blob) => {
				const url = URL.createObjectURL(blob);
				window.open(url, '_blank');
			}, true, 'POST');
		},
		getDataLimite() {
			utils.get('theb/note_spese/data-limite', {
				FK_ID_UTENTE: this.form.FK_ID_UTENTE
			}, (res) => {
				if (res.esito == 0) {
					this.dataLimite = res.data || null;
				}
			});
		},
		checkDataWarning() {
			if (this.dataLimite && this.form.DATA) {
				const date = this.form.DATA instanceof Date ? this.form.DATA : new Date(this.form.DATA);
				const selectedDate = date.getTime();
				const limiteDate = new Date(this.dataLimite).getTime();
				this.dataWarning = selectedDate <= limiteDate;
			} else {
				this.dataWarning = false;
			}
		},
		salvaSpesa(continua = false) {
			if (this.dataWarning && !this.notaSpesa) {
				this.message = 'La data non può essere uguale o precedente al limite. Operazione bloccata.';
				this.messageClass = 'alert-danger';
				return;
			}

			this.loading = true;
			this.message = '';

			const payload = {
				FK_ID_UTENTE: this.form.FK_ID_UTENTE,
				DATA: this.filters.formatDateOnly(this.form.DATA),
				IMPORTO: this.form.IMPORTO,
				DESCRIZIONE: this.form.DESCRIZIONE,
				FK_ID_PROGETTO: this.form.FK_ID_PROGETTO || null,
				FLG_ATTIVO: this.form.FLG_ATTIVO,
				DATA_ADD: this.notaSpesa ? this.notaSpesa.DATA_ADD : new Date().toISOString().split('T')[0],
				FILE_ALLEGATO: this.notaSpesa ? this.notaSpesa.FILE_ALLEGATO : null,
				TIPO_MOVIMENTO: this.form.TIPO_MOVIMENTO,
				FK_ID_CATEGORIA: this.form.FK_ID_CATEGORIA || null,
				FLG_FATTURA: this.form.FLG_FATTURA
			};

			if (this.notaSpesa) {
				payload.ID_NOTA_SPESA = this.notaSpesa.ID_NOTA_SPESA;
			}

			const isUpdate = !!this.notaSpesa;
			const endpoint = isUpdate ? 'theb/note_spese/update' : 'theb/note_spese/insert';

			(isUpdate ? utils.put : utils.post)(endpoint, payload, (res) => {
				this.loading = false;
				if (res.esito == 0) {
					utils.notifiche.invia(this, endpoint == 'theb/note_spese/insert' ? 'NOTA_SPESA_CREA' : 'NOTA_SPESA_MODIFICA', endpoint == 'theb/note_spese/insert' ? 'ha creato una nota spesa' : 'ha modificato una nota spesa');

					if (continua) {
						const prevUtente = this.form.FK_ID_UTENTE;
						this.form = {
							FK_ID_UTENTE: prevUtente,
							DATA: '',
							IMPORTO: '',
							DESCRIZIONE: '',
							FK_ID_PROGETTO: this.defaultIdProgetto || '',
							FLG_ATTIVO: 1,
							TIPO_MOVIMENTO: 0,
							FK_ID_CATEGORIA: '',
							FLG_FATTURA: null
						};
						this.dataWarning = false;
						this.message = '';
						if (prevUtente) this.getDataLimite();
						utils.alert.success('Nota spesa salvata');
					} else {
						this.$emit('saved');
					}
				} else {
					this.message = res.messaggio || 'Errore nel salvataggio';
					this.messageClass = 'alert-danger';
				}
			});
		},
		close() {
			this.$emit('close');
		},
		formatData(data) {
			if (!data) return '';
			const d = new Date(data);
			return d.toLocaleDateString('it-IT');
		}
	}
};
</script>

<style scoped>
.modal {
	z-index: 1050;
}

.modal.show {
	background-color: rgba(0, 0, 0, 0.5);
}

@media (max-width: 575.98px) {
	.modal-footer {
		flex-direction: column-reverse;
	}
	.modal-footer > * {
		width: 100%;
		margin-left: 0 !important;
		margin-right: 0 !important;
	}
}
</style>
